var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCristalinaLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 258,
    height: 83,
    viewBox: "0 0 258 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5116 33.9729L38.928 41.6484C37.4598 43.2461 35.8189 44.6063 34.0053 45.729C30.5508 47.8665 26.7724 48.9352 22.6702 48.9352C18.5896 48.9352 14.8112 47.8665 11.3351 45.729C7.83741 43.57 5.0738 40.666 3.04428 37.0172C1.01476 33.3468 0 29.3201 0 24.9372C0 20.5327 1.01476 16.4953 3.04428 12.8249C5.0738 9.17603 7.83741 6.26129 11.3351 4.08063C14.8112 1.94316 18.5896 0.874422 22.6702 0.874422C26.7724 0.874422 30.5508 1.94316 34.0053 4.08063C35.8189 5.20335 37.4382 6.54197 38.8632 8.0965L31.4468 15.772C30.5184 14.6709 29.6224 13.8396 28.7588 13.2783C26.8588 12.0044 24.8293 11.3675 22.6702 11.3675C20.5111 11.3675 18.4816 12.0044 16.5816 13.2783C14.7248 14.5521 13.2459 16.2362 12.1447 18.3305C11.0652 20.4464 10.5254 22.6486 10.5254 24.9372C10.5254 27.2258 11.076 29.4281 12.1771 31.544C13.2783 33.6382 14.7572 35.3223 16.614 36.5962C18.4708 37.87 20.4895 38.5069 22.6702 38.5069C24.8508 38.5069 26.8696 37.87 28.7264 36.5962C29.7195 35.9269 30.6479 35.0524 31.5116 33.9729Z",
    fill: "url(#paint0_linear_25696_9791)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5499 13.6345V23.4151C57.0101 23.048 56.3084 22.8429 55.4448 22.7997H54.8619C52.2278 22.9077 50.9108 24.7429 50.9108 28.3054V47.9313H40.5473V28.3054C40.5473 18.8702 45.3188 13.9152 54.8619 13.4402H55.4448C56.1573 13.4618 56.859 13.5265 57.5499 13.6345Z",
    fill: "url(#paint1_linear_25696_9791)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9213 14.8004V47.996H59.5902V14.8328L69.9213 14.8004ZM69.9537 5.40846C69.9537 6.44481 69.7162 7.36241 69.2412 8.16127C68.7662 8.96012 68.1185 9.60784 67.2981 10.1044C66.4776 10.601 65.5708 10.8493 64.5777 10.8493C63.5845 10.8493 62.6885 10.6118 61.8896 10.1368C61.0692 9.64023 60.4215 8.98171 59.9465 8.16127C59.4499 7.29764 59.2016 6.38004 59.2016 5.40846C59.2016 4.41529 59.4391 3.50848 59.9141 2.68804C60.4323 1.846 61.0908 1.18749 61.8896 0.712492C62.6885 0.237497 63.5845 0 64.5777 0C65.5708 0 66.4776 0.237497 67.2981 0.712492C68.0969 1.18749 68.7447 1.846 69.2412 2.68804C69.7162 3.50848 69.9537 4.41529 69.9537 5.40846Z",
    fill: "url(#paint2_linear_25696_9791)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8196 37.503C78.8707 39.5541 81.3752 40.5796 84.3331 40.5796C87.4206 40.5796 88.9643 39.6728 88.9643 37.8592C88.9643 36.9092 88.1115 36.2075 86.4058 35.7541C85.1967 35.4735 83.2752 34.9877 80.6411 34.2968C78.5036 33.7354 76.7008 32.6991 75.2326 31.1877C73.7861 29.698 73.0628 27.4093 73.0628 24.3219C73.0628 21.9469 73.6565 19.939 74.844 18.2981C76.0531 16.6572 77.6184 15.4481 79.54 14.6709C81.5047 13.872 83.653 13.4726 85.9848 13.4726C87.3018 13.4726 88.6404 13.6561 90.0007 14.0231C91.4688 14.4765 92.7858 15.0379 93.9517 15.7072C95.2256 16.4197 96.3483 17.2186 97.3199 18.1038L91.62 23.7713C89.9575 22.5191 88.1439 21.8929 86.1791 21.8929C83.8257 21.8929 82.649 22.5514 82.649 23.8685C82.649 25.056 83.5235 25.8872 85.2723 26.3622C87.1939 26.8804 89.1262 27.3662 91.0694 27.8196C93.2069 28.3593 94.9881 29.3525 96.4131 30.7991C97.8597 32.2672 98.5829 34.5774 98.5829 37.7297C98.5829 40.0831 97.9568 42.1126 96.7046 43.8182C95.4523 45.5455 93.779 46.8301 91.6847 47.6722C89.5904 48.5574 87.4206 49 85.1751 49C83.2968 49 81.6019 48.8489 80.0905 48.5466C78.5792 48.2659 77.165 47.7909 75.848 47.1216C74.4878 46.4523 73.0628 45.5563 71.573 44.4336L76.8196 37.503Z",
    fill: "url(#paint3_linear_25696_9791)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M104.639 23.6094H97.8057L100.137 14.7356H104.639V1.97555L114.97 2.04032V14.7356H121.836L119.537 23.6094H114.97V34.5882C114.97 37.5246 116.805 38.9927 120.476 38.9927C121.663 38.9927 122.57 38.8524 123.196 38.5717L120.217 48.8705C119.677 48.9568 119.148 49 118.63 49C115.542 49 112.973 48.5034 110.922 47.5102C108.849 46.5171 107.284 45.0165 106.226 43.0086C105.168 41.0223 104.639 38.4853 104.639 35.3979V23.6094Z",
    fill: "url(#paint4_linear_25696_9791)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M139.551 23.9332C138.213 24.6889 137.144 25.7037 136.345 26.9775C135.546 28.2514 135.147 29.644 135.147 31.1553C135.147 33.4439 136.01 35.4195 137.738 37.082C139.443 38.7228 141.462 39.5433 143.794 39.5433C146.147 39.5433 148.177 38.7228 149.882 37.082C151.61 35.4195 152.473 33.4439 152.473 31.1553C152.473 29.644 152.074 28.2514 151.275 26.9775C150.476 25.7037 149.407 24.6889 148.069 23.9332C146.752 23.1992 145.327 22.8321 143.794 22.8321C142.304 22.8321 140.89 23.1992 139.551 23.9332ZM152.506 47.9313V46.9597C151.815 47.262 151.307 47.4671 150.983 47.575C148.695 48.4602 146.298 48.9028 143.794 48.9028C140.49 48.9028 137.371 48.1364 134.434 46.6034C131.498 45.0489 129.166 42.933 127.439 40.2558C125.69 37.5354 124.816 34.5019 124.816 31.1553C124.816 28.6292 125.323 26.2758 126.338 24.0952C127.352 21.9361 128.745 20.0577 130.516 18.46C132.264 16.8623 134.294 15.6424 136.604 14.8004C138.914 13.9152 141.311 13.4726 143.794 13.4726C146.255 13.4726 148.652 13.9044 150.983 14.768C153.315 15.6316 155.345 16.8623 157.072 18.46C158.886 20.1009 160.289 21.9793 161.282 24.0952C162.297 26.2758 162.804 28.6292 162.804 31.1553L162.772 48.0284L152.506 47.9313Z",
    fill: "url(#paint5_linear_25696_9791)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M164.456 1.97555L174.787 1.94316V47.8665L164.456 47.996V1.97555Z",
    fill: "url(#paint6_linear_25696_9791)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M187.159 14.8004V47.996H176.827V14.8328L187.159 14.8004ZM187.191 5.40846C187.191 6.44481 186.954 7.36241 186.479 8.16127C186.004 8.96012 185.356 9.60784 184.535 10.1044C183.715 10.601 182.808 10.8493 181.815 10.8493C180.822 10.8493 179.926 10.6118 179.127 10.1368C178.306 9.64023 177.659 8.98171 177.184 8.16127C176.687 7.29764 176.439 6.38004 176.439 5.40846C176.439 4.41529 176.676 3.50848 177.151 2.68804C177.67 1.846 178.328 1.18749 179.127 0.712492C179.926 0.237497 180.822 0 181.815 0C182.808 0 183.715 0.237497 184.535 0.712492C185.334 1.18749 185.982 1.846 186.479 2.68804C186.954 3.50848 187.191 4.41529 187.191 5.40846Z",
    fill: "url(#paint7_linear_25696_9791)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M203.708 22.8321H203.125C200.491 22.9401 199.174 24.7753 199.174 28.3377V47.9313H188.81V28.3377C188.81 18.9026 193.582 13.9476 203.125 13.4726H203.708C213.251 13.9476 218.022 18.9026 218.022 28.3377V47.9313H207.659V28.3377C207.659 24.7753 206.342 22.9401 203.708 22.8321Z",
    fill: "url(#paint8_linear_25696_9791)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M234.377 23.9332C233.039 24.6889 231.97 25.7037 231.171 26.9775C230.372 28.2514 229.973 29.644 229.973 31.1553C229.973 33.4439 230.837 35.4195 232.564 37.082C234.269 38.7228 236.288 39.5433 238.62 39.5433C240.973 39.5433 243.003 38.7228 244.709 37.082C246.436 35.4195 247.299 33.4439 247.299 31.1553C247.299 29.644 246.9 28.2514 246.101 26.9775C245.302 25.7037 244.234 24.6889 242.895 23.9332C241.578 23.1992 240.153 22.8321 238.62 22.8321C237.13 22.8321 235.716 23.1992 234.377 23.9332ZM247.332 47.9313V46.9597C246.641 47.262 246.133 47.4671 245.81 47.575C243.521 48.4602 241.124 48.9028 238.62 48.9028C235.317 48.9028 232.197 48.1364 229.26 46.6034C226.324 45.0489 223.992 42.933 222.265 40.2558C220.516 37.5354 219.642 34.5019 219.642 31.1553C219.642 28.6292 220.149 26.2758 221.164 24.0952C222.179 21.9361 223.571 20.0577 225.342 18.46C227.091 16.8623 229.12 15.6424 231.43 14.8004C233.74 13.9152 236.137 13.4726 238.62 13.4726C241.081 13.4726 243.478 13.9044 245.81 14.768C248.141 15.6316 250.171 16.8623 251.898 18.46C253.712 20.1009 255.115 21.9793 256.108 24.0952C257.123 26.2758 257.631 28.6292 257.631 31.1553L257.598 48.0284L247.332 47.9313Z",
    fill: "url(#paint9_linear_25696_9791)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M3.7688 74.4952C4.52667 74.4952 5.1632 74.7621 5.6784 75.296C6.1936 75.8299 6.4512 76.5037 6.4512 77.3176C6.4512 78.1315 6.1936 78.8053 5.6784 79.3392C5.1632 79.8731 4.52667 80.14 3.7688 80.14C3.05573 80.14 2.49573 79.8805 2.0888 79.3616V80H0.9184V71.936H2.0888V75.2736C2.49573 74.7547 3.05573 74.4952 3.7688 74.4952ZM3.6288 75.5984C3.15093 75.5984 2.7608 75.7608 2.4584 76.0856C2.15973 76.4104 2.0104 76.8211 2.0104 77.3176C2.0104 77.8141 2.15973 78.2248 2.4584 78.5496C2.7608 78.8744 3.15093 79.0368 3.6288 79.0368C4.11787 79.0368 4.50987 78.8725 4.8048 78.544C5.09973 78.2117 5.2472 77.8029 5.2472 77.3176C5.2472 76.8323 5.09973 76.4253 4.8048 76.0968C4.50987 75.7645 4.11787 75.5984 3.6288 75.5984ZM12.9517 74.6352L8.71806 82.2736H7.41886L9.33966 78.8968L6.95966 74.6352H8.27566L10.0005 77.7152L11.6637 74.6352H12.9517Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8024 79.5653C38.6444 79.5653 38.1268 78.5428 38.1268 77.5282V71.9965H42.3249V69.2017H32.9785V71.9965H34.8517V77.2054C34.8517 78.9004 35.3022 80.2069 36.1916 81.0899C36.9843 81.8773 38.1138 82.293 39.4603 82.293C41.6445 82.293 43.1291 80.984 43.4725 80.6509L42.0835 78.6461C41.7698 78.9095 40.8829 79.5653 39.8024 79.5653Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4487 69.2017H72.1143V82.0877H75.4487V69.2017Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7213 79.5653C65.5634 79.5653 65.0457 78.5428 65.0457 77.5282V71.9965H69.2438V69.2017H65.0457H61.7706H59.8975V71.9965H61.7706V77.2054C61.7706 78.9004 62.2211 80.2069 63.1106 81.0899C63.9032 81.8773 65.0328 82.293 66.3792 82.293C68.5635 82.293 70.0481 80.984 70.3915 80.6509L69.0024 78.6461C68.69 78.9095 67.8018 79.5653 66.7213 79.5653Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0968 79.6037H90.1522C91.0132 78.4974 91.5231 77.129 91.5231 75.6457C91.5231 71.9756 88.4016 69 84.5521 69C80.7025 69 77.5811 71.9756 77.5811 75.6457C77.5811 79.2061 80.5179 82.112 84.2074 82.2837V82.2914H84.5521C84.5521 82.2914 84.5521 82.2914 84.5534 82.2914C84.5547 82.2914 84.5534 82.2914 84.5547 82.2914H93.0994V79.6037H93.0968ZM80.9504 75.6457C80.9504 73.5815 82.5628 71.9085 84.5521 71.9085C86.5414 71.9085 88.1538 73.5815 88.1538 75.6457C88.1538 77.7099 86.5414 79.383 84.5521 79.383C82.5628 79.383 80.9504 77.7099 80.9504 75.6457Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5853 70.9506L54.4743 70.8254C53.3306 69.648 51.837 69 50.2711 69C46.7778 69 44.041 71.9201 44.041 75.647C44.041 79.4359 46.7197 82.294 50.2711 82.294C51.8382 82.294 53.3306 81.646 54.4743 80.4686L54.5853 80.3473V82.0901H57.9547V69.204H54.5853V70.9506ZM50.994 79.5869C48.9956 79.5869 47.3703 77.8674 47.3703 75.7529C47.3703 73.7752 48.7258 71.729 50.994 71.729C52.9575 71.729 54.6163 73.5725 54.6163 75.7529C54.6163 77.8674 52.9911 79.5869 50.994 79.5869Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M26.479 74.4387C24.7143 74.0927 22.8824 73.881 22.8824 72.807C22.8824 71.9769 24.0107 71.5276 25.4011 71.5276C27.2535 71.5276 27.9842 72.2815 27.9842 72.8754H31.4542C31.4542 70.0134 28.436 69 25.4217 69C22.1273 69 19.5996 70.6137 19.5996 72.8754C19.5996 75.8832 22.6578 76.4138 25.1906 76.8385C27.0018 77.1419 28.6323 77.3794 28.6323 78.3605C28.6323 79.1777 27.7544 79.7418 25.6954 79.7418C23.08 79.7418 22.8837 78.4406 22.8837 78.4406H19.6048C19.6048 80.022 21.2765 82.2927 25.6954 82.2927C29.5669 82.2927 31.9267 80.7526 31.9267 78.2082C31.9254 75.4469 28.844 74.9034 26.479 74.4387Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25696_9791",
    x1: 0,
    y1: 24.5,
    x2: 257.631,
    y2: 24.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495192,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFAFAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_25696_9791",
    x1: 0,
    y1: 24.5,
    x2: 257.631,
    y2: 24.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495192,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFAFAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_25696_9791",
    x1: 0,
    y1: 24.5,
    x2: 257.631,
    y2: 24.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495192,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFAFAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_25696_9791",
    x1: 0,
    y1: 24.5,
    x2: 257.631,
    y2: 24.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495192,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFAFAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_25696_9791",
    x1: 0,
    y1: 24.5,
    x2: 257.631,
    y2: 24.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495192,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFAFAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_25696_9791",
    x1: 0,
    y1: 24.5,
    x2: 257.631,
    y2: 24.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495192,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFAFAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_25696_9791",
    x1: 0,
    y1: 24.5,
    x2: 257.631,
    y2: 24.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495192,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFAFAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_25696_9791",
    x1: 0,
    y1: 24.5,
    x2: 257.631,
    y2: 24.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495192,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFAFAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_25696_9791",
    x1: 0,
    y1: 24.5,
    x2: 257.631,
    y2: 24.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495192,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFAFAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_25696_9791",
    x1: 0,
    y1: 24.5,
    x2: 257.631,
    y2: 24.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495192,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFAFAF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCristalinaLogo);
export default __webpack_public_path__ + "static/media/cristalina_logo.c850a1df319a631df9dcff7452945395.svg";
export { ForwardRef as ReactComponent };